import api from "./api";
import endpoints from "./endpoints";

export default {
  getMasterData: async function (nodeId, catalogId, languageCode) {
    const response = await api.get(endpoints.catalogNodes.masterData.get, {
      params: { nodeId, catalogId, languageCode }
    });
    return response.data;
  },
  getCatalogNodePathInBaseCatalog: async function (nodeId, languageCode) {
    const response = await api.get(endpoints.catalogNodes.path.getFromBaseCatalog, { params: { nodeId, language: languageCode } });
    return response.data;
  },
  getCatalogNodePath: async function (catalogId, nodeId, languageCode) {
    const response = await api.get(endpoints.catalogNodes.path.get, {
      params: { catalogId, nodeId, language: languageCode }
    });
    return response.data;
  },
  getMediaAssets: async function (args) {
    const response = await api.get(endpoints.catalogNodes.mediaAssets.get, {
      params: args
    });
    return response.data;
  },
  getAttributes: async function (nodeId, catalogId, languageCode) {
    const response = await api.get(endpoints.catalogNodes.attributes.get, {
      params: { nodeId, catalogId, languageCode }
    });
    return response.data;
  },
  updateMasterData(language, model) {
    return api
      .post(endpoints.catalogNodes.masterData.update, model, {
        params: { language }
      })
      .then((x) => Promise.resolve(x.data));
  },
  updateAttributeData(language, model) {
    return api
      .post(endpoints.catalogNodes.attributes.update, model, {
        params: { language }
      })
      .then((x) => Promise.resolve(x.data));
  },
  updateMediaAssets(id, languageCode, mediaAssets) {
    return api
      .post(endpoints.catalogNodes.mediaAssets.update, mediaAssets, {
        params: { nodeId: id, languageCode }
      })
      .then((x) => Promise.resolve(x.data));
  },
  getStatus: async function (language, nodeIds) {
    const response = await api.post(endpoints.catalogNodes.status.get, nodeIds, {
      params: { language }
    });
    return response.data;
  },
  deleteEmptyCatalogGroups: async function (catalogId) {
    const response = await api.post(endpoints.catalogNodes.deleteEmpty, {}, { params: { catalogId } });
    return response.data;
  },
  getChildrenCount: async function (nodeId, type, abortSignal) {
    let nodeType;
    if (type == "CatalogGroup") nodeType = 1;
    if (type == "VariationGroup") nodeType = 2;
    const response = await api.get(endpoints.catalogs.nodes.childCount, {
      params: { nodeId, nodeType },
      signal: abortSignal
    });
    const data = response.data;
    if (nodeType == 1) return data.catalogNodesCount;
    if (nodeType == 2) return data.catalogArticlesCount;
    return 0;
  },
  getNewChildOptions: async function (nodeId) {
    const response = await api.get(endpoints.catalogNodes.newChildOptions, {
      params: { nodeId }
    });
    return response.data;
  }
};
